import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location } from '@angular/common';
import { MatDialog, MatDialogRef } from '@angular/material';
import { LoginClientComponent } from '../../mnt-master/login-client/login-client.component';
import { RegisterClientComponent } from '../../mnt-master/register-client/register-client.component';
@Component({
  selector: 'app-public-client-account',
  templateUrl: './public-client-account.component.html',
  styleUrls: ['./public-client-account.component.css']
})
export class PublicClientAccountComponent implements OnInit {
  loading: false;
  public result = "";
  public validate_address=false;
  public userDetails:any={};
  public countryList:Array<any>=[]; 
  public isPublicQuoteCreation = false;
  constructor(
    public dialogRef: MatDialogRef<PublicClientAccountComponent>,
    public dialog: MatDialog,
    private router: Router,
    private location: Location
  ) { 
    this.userDetails = (localStorage.getItem('userDetails')) ? JSON.parse(localStorage.getItem('userDetails')) : false;
  }

  ngOnInit() {
  }


  onNoClick(): void {
    this.dialogRef.close();
  }

  openLoginClientDialog(): void {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(LoginClientComponent, {
      width: "500px",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });
    dialogRef.afterClosed().subscribe(result => {     
      if (result && result != "success") {
        const currentUrl = this.location.path();
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate([currentUrl]);
        });
      }
    });
  }

  openRegisterClientDialog(): void {
    this.dialogRef.close();
    const dialogRef = this.dialog.open(RegisterClientComponent, {
      width: "500px",
      disableClose: true,
      data: {
        saveFrom: 'BuilderOrder'
      }
    });

    dialogRef.afterClosed().subscribe(result => {     
      if (result && result != "success") {
        const currentUrl = this.location.path();
        this.router.navigateByUrl('/', {skipLocationChange: true}).then(() => {
            this.router.navigate([currentUrl]);
        });
      }
    });
  }

}



// WEBPACK FOOTER //
// /var/www/login.theprintlife.com/src/app/mnt-public-quote/public-client-account/public-client-account.component.ts